'use client';

import applicationMonitoring from '$utils/monitoring';
import { logger, applyPromisePolyfill } from '@brahma/utils';
import type React from 'react';
import { useEffect } from 'react';

// Apply Promise.withResolvers polyfill for older browsers (Opera 89, Chrome <119, etc.)
// This runs at module load time, ensuring it's available before PDF.js or other code needs it
applyPromisePolyfill();
const MonitoringHelper: React.FC = () => {
  useEffect(() => {
    logger.initializeLogger();
    if (process.env.NEXT_PUBLIC_ENABLE_RUM) {
      applicationMonitoring.init();
    }
  }, []);
  return null;
};
export default MonitoringHelper;